import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as ReviewerInteractionActions from '../actions/reviewer-interaction.actions';
import * as ReviewerInteractionReducer from '../reducers/reviewer-interaction.reducer';
import * as ReviewerInteractionSelectors from '../selectors/reviewer-interaction.selectors';

@Injectable()
export class ReviewerInteractionFacade {
  constructor(
    private readonly store: Store<ReviewerInteractionReducer.State>
  ) {}

  loadReviewInteractionById$ = (id: string, uid: string) => {
    return this.store.dispatch(
      ReviewerInteractionActions.loadReviewInteractionById({ id, uid })
    );
  };

  selectSingleInteraction$ = (recordingId: string) =>
    this.store.pipe(
      select(ReviewerInteractionSelectors.selectSingleInteraction(recordingId))
    );
}
